import { Injectable } from '@angular/core';

import { ApplicationHttpClient } from './../http-client';
import { map } from 'rxjs/operators';
import { ILogger } from '@base/interfaces';

interface IResult1 {
  company_id: number;
  company_name: string;
  hour: number;
  total: number;
}

@Injectable()
export class LoggerService {

  constructor(
    private http: ApplicationHttpClient,
  ) { }

  getAllLogs() {
    return this.http.Get('logs/');
  }

  getLogsByDate(range: object) {
    return this.http.Post('logs/companylogs/', range)
    .pipe(
      map((logs: []) => {
        logs.map((log: IResult1) => {
          const hour = log.hour - 3;
          log.hour = hour;
        });
        return logs;
      })
    );
  }

  getCompanyCustomersLog(range: object) {
    return this.http.Post('logs/companycustomerslog/', range)
    .pipe(
      map((logs: []) => {
        logs.map((log: IResult1) => {
          log.hour = log.hour - 3;
        });
        return logs;
      })
    );
  }
}
